/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import { saveQueueAC } from '../../action-creators';
import { setInitialValues } from './utils/form-utils';
import { Field, Formik } from 'formik';
import { CheckboxField, ControlBoxField, InputField } from './fields';
import { ActionsSection } from './buttons/actions-section';
import { LocationField } from './fields/location-field';
import { DropdownField } from './fields/dropdown-field';
import { ServicesField } from './fields/services-field';

const FIELDS = [
  'locationId',
  'priority',
  'controlBoxId',
  'sequenceId',
  'name',
  'priority',
  'serviceIds',
  { key: 'allowRemoteCheckin', value: false },
  'maxCheckinsPerDevice',
  { key: 'visibleForMobile', value: false },
  { key: 'visibleForMobileBeta', value: false }
];
function QueueForm(props: any) {
  const { dispatch, onClose } = props;
  const boundHandleSubmit = (values: any, formikActions: any) =>
    dispatch(saveQueueAC({ data: values, formikActions, closeDialog: onClose }));
  return (
    <Formik initialValues={setInitialValues(FIELDS, props)} onSubmit={boundHandleSubmit}>
      {({ values, handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <Field name="name" label="Name" component={InputField} />
          <Field name="serviceIds" component={ServicesField} />
          <Field name="sequenceId" label="Queue number (sequence Id)" component={InputField} />
          <Field label="Priority" name="priority">
            {(props: any) => (
              <DropdownField
                {...props}
                label="priority"
                options={[
                  { value: 3, text: '3 - normal' },
                  { value: 2, text: '2 - high' },
                  { value: 1, text: '1 - top' }
                ]}
              />
            )}
          </Field>
          <Field name="controlBoxId" component={ControlBoxField} />
          <Field name="locationId" component={LocationField} />
          <Field label="Visible for mobile users?" name="visibleForMobile" component={CheckboxField} />
          <Field label="Allow users to check-in remotely?" name="allowRemoteCheckin" component={CheckboxField} />
          <Field label="Max check-ins per device and day" name="maxCheckinsPerDevice">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Max check-ins per device and day"
                options={[
                  { value: '1', text: '1' },
                  { value: '2', text: '2' },
                  { value: '5', text: '5' },
                  { value: '10', text: '10' },
                  { value: '20', text: '20' },
                  { value: '100', text: '100' }
                ]}
              />
            )}
          </Field>
          <ActionsSection isNew={!values.id} disabled={isSubmitting} onCancel={props.onClose} />
        </Form>
      )}
    </Formik>
  );
}

const ConnectedComponent = connect((state: any) => ({
  app: state.app,
  serviceProviders: state.serviceProviders,
  locations: state.locations,
  services: state.services,
  controlBoxes: state.controlBoxes
}))(QueueForm);

export default ConnectedComponent;
